export const config = {
    content: {
        location_input_label: {
            heading: "Wo bist du unterwegs?",
            placeholder: "PLZ oder Ort eingeben",
            aria_label: "Wo bist du unterwegs?"
        },
        category_heading: "Welche Verkehrsmittel nutzt du?",
        gesture_handling_options: {
            text: {
                touch: "Verschieben der Karte mit zwei Fingern",
                scroll: "Verwende Strg+Scrollen zum Zoomen der Karte",
                scrollMac: "\u2318"
            },
            duration: 1000
        },
        usage_hint: {

        },
        fetch_states: {
            loading: "Datensätze werden geladen...",
            error: "Fehler beim Laden der Daten"
        },
        modal: {
            location_warning: {
                heading: "Der Ort muss sich in NRW befinden."
            }
        },
        provider_popup: {
            read_more: "Weitere Informationen",
            playstore: {
                id: "appicon_google",
                alt: "Google Playstore"
            },
            appstore: {
                id: "appicon_apple",
                alt: "Apple Appstore"
            }
        }
    },
    map: {
        zoom_level: {
            default: 9,
            min: 7.5,
            max: 18,
            on_location_success: 12,
            on_location_failed: 8,
        },
        center: {
            default: {
                lat: 51.4457967,
                lng: 6.9761637
            }
        },
        postcodes: {
            default: '45128'
        },
        modal: {
            location_warning: {
                delay: 200
            }
        },
    }
}
